import EntryPoint from 'Engine/EntryPoint';

import gameConfig from '../../assets/config';

import UbuntuBold from '../../assets/fonts/ubuntu/UBUNTU-B.TTF';
import UbuntuRegular from '../../assets/fonts/ubuntu/UBUNTU-R.TTF';
import MyriadPro from '../../assets/fonts/ubuntu/MYRIADPRO-BOLD.OTF';
import eSoundType from '../sounds/eSoundType';

import falashlibDesktop from '../../assets/exported/game/FlashLib.json';
import flashlibMobile from '../../assets/exported/gameMobile/FlashLib.json';
import Config from "../Config";

import {getAssetsScale} from "Engine/utils/getAssetsScale";

// import desktopAssets from '../../assets/exported/game/FlashLibAssets';
// import mobileAssets from '../../assets/exported/gameMobile/FlashLibAssets';

const scale = getAssetsScale({
  availableScales: ['0.7','0.75','0.8','0.9'],
  safeWidthLandscape: Config.SAFE_WIDTH_LANDSCAPE,
  safeHeightLandscape: Config.SAFE_HEIGHT_LANDSCAPE,
  safeWidthPortrait: Config.SAFE_WIDTH_PORTRAIT,
  safeHeightPortrait: Config.SAFE_HEIGHT_PORTRAIT,
})

const desktopAssets = `flashlib/game/AssetsCombined@${scale}x.json`;
const mobileAssets = `flashlib/gameMobile/AssetsCombined@${scale}x.json`;

let assets = EntryPoint.mobile ? mobileAssets : desktopAssets;
let flashlib = EntryPoint.mobile ? flashlibMobile : falashlibDesktop;

export default {
  assets: [
    {name: 'GameAssets', path: assets, extension: 'json'},
    {name: 'GameFlashLib', path: flashlib, extension: 'json'},
    {name: 'gameConfig', path: gameConfig, extension: 'json'},
    {name: 'symbols', path: 'animations/symbols/777_symbols.json', extension: 'json'},
    {name: 'background', path: 'animations/background/bg_777.json', extension: 'json'},
    {name: 'coins', path: 'animations/coins/skeleton.json', extension: 'json'},
    {name: 'jackpot_panel', path: 'animations/sweep_dwb/skeleton.json', extension: 'json'},
    {name: 'BMFont', path: 'fonts/BMFont/BMFont.xml', extension: 'xml'},
  ],
  delayedAssets: [
    {name: 'bigWin_spine', path: 'animations/bigWins/DWB_b_o_e.json', extension: 'json'},
    {name: 'antisipator', path: 'animations/antisipator/antisipator_777.json', extension: 'json'},
  ],
  fonts: [
    { name: 'UbuntuBold',
      path: UbuntuBold,
    },
    {
      name: 'UbuntuRegular',
      path: UbuntuRegular,
    },
    {
      name: 'Myriad Pro',
      path: MyriadPro,
    },
  ],
  sounds: eSoundType
}
